var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTimeSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Regular/Outline/Time Square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Time Square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26171 4.24239C6.20463 4.24239 4.229 6.33378 4.229 9.57163V19.4288C4.229 22.6666 6.20463 24.758 9.26171 24.758H19.7355C22.7938 24.758 24.7707 22.6666 24.7707 19.4288V9.57163C24.7707 6.33378 22.795 4.24239 19.7368 4.24239H9.26171ZM19.7355 26.5682H9.26171C5.16667 26.5682 2.4165 23.6985 2.4165 19.4288V9.57163C2.4165 5.30197 5.16667 2.43219 9.26171 2.43219H19.7368C23.8318 2.43219 26.5832 5.30197 26.5832 9.57163V19.4288C26.5832 23.6985 23.8318 26.5682 19.7355 26.5682Z",
    fill: "#722ED1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.596 17.8402C18.4377 17.8402 18.2782 17.7991 18.132 17.7134L14.0345 15.2721C13.7615 15.108 13.5923 14.8123 13.5923 14.4949V9.23083C13.5923 8.73121 13.9983 8.32573 14.4985 8.32573C14.9988 8.32573 15.4048 8.73121 15.4048 9.23083V13.9808L19.0612 16.1567C19.4902 16.4137 19.6315 16.9688 19.3754 17.3985C19.205 17.6821 18.9041 17.8402 18.596 17.8402Z",
    fill: "#722ED1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeSquare);
export default __webpack_public_path__ + "static/media/icon-time-square.891bcc5b6c23595c12e28bce9ec39b2e.svg";
export { ForwardRef as ReactComponent };